import { render, staticRenderFns } from "./OperaAnchorPassWindow.vue?vue&type=template&id=00ddfe91&"
import script from "./OperaAnchorPassWindow.vue?vue&type=script&lang=js&"
export * from "./OperaAnchorPassWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports